const state = {
  currencyToggleByPayment: true,
  isPaymentLoading: false,
  fallbackOnsiteSession: null,
  fallbackOnsiteToken: null
}

const getters = {
  currencyToggleByPayment: (state) => {
    return state.currencyToggleByPayment
  },
  isPaymentLoading: (state) => {
    return state.isPaymentLoading
  },
  getFallbackOnsiteSession(state) {
    return state.fallbackOnsiteSession
  },
  getFallbackOnsiteToken(state) {
    return state.fallbackOnsiteToken
  }
}

const mutations = {
  setFallbackOnsiteSession: (state, payload) => {
    state.fallbackOnsiteSession = payload
  },
  setFallbackOnsiteToken: (state, payload) => {
    state.fallbackOnsiteToken = payload
  },
  setCurrencyToggleByPayment: (state, payload) => {
    state.currencyToggleByPayment = payload
  },
  setIsPaymentLoading: (state, payload) => {
    state.isPaymentLoading = payload
  }
}

const actions = {
  setCurrencyToggleByPayment: ({ commit }, payload) => {
    commit('setCurrencyToggleByPayment', payload)
  },
  setIsPaymentLoading: ({ commit }, payload) => {
    commit('setIsPaymentLoading', payload)
  },
  setFallbackOnsiteSession: ({ commit }, payload) => {
    commit('setFallbackOnsiteSession', payload)
  },
  setFallbackOnsiteToken: ({ commit }, payload) => {
    commit('setFallbackOnsiteToken', payload)
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
}
